import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductDao } from '@app/dao/product/product.dao';
import { CommandEnum } from '@app/forms/subscription/definition/interface/enum';
import { ProductsTypeEnum } from '@app/forms/subscription/definition/interface/question.interface';
import { catchError, of, take } from 'rxjs';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'fees-form',
    templateUrl: './fees-form.component.html',
    styleUrls: ['./fees-form.component.scss'],
    standalone: false
})
export class FeesFormComponent extends EaSubscriptionBuilder implements OnInit {
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  displayFees: boolean = false;
  minFees: number = 0;
  maxFees: number = 100;

  get placeSignatureLocked(): boolean {
    return !!this.entity?.parameters?.placeSignatureLocked;
  }

  ngOnInit(): void {
    const pledge = this.subscriptionFacade.getPledge();

    // fees AV displayed in life-insurance-fees-form
    // this.displayFees = pledge?.productType == "ASSURANCE_VIE";
    this.displayFees = false;

    if (this.displayFees) {
      this.productDao
        .getProduct(pledge?.products?.[0]?.productId as any)
        .subscribe(product => {
          this.minFees = this.floorValue(
            product.lifeInsuranceMinInitialPaymentFee * 100,
          );
          this.maxFees = this.floorValue(
            product.lifeInsuranceMaxInitialPaymentFee * 100,
          );

          if (!this.maxFees || this.maxFees < this.minFees)
            this.maxFees = this.minFees;

          if (this.minFees === this.maxFees) {
            this.displayFees = false;
            this.form.get('fees').setValidators([Validators.nullValidator]);
            this.form.get('fees').updateValueAndValidity();

            return;
          }
          if (this.form.get('fees').value * 100 < this.minFees)
            this.form.get('fees').setValue(this.minFees);
        });
    }

    this.subscriptionFacade.initForm(this);
    if (pledge?.productType === ProductsTypeEnum.SCPI) {
      this.completeSignaturePlace(pledge);
    }
  }

  completeSignaturePlace(pledge) {
    const command$ = this.subscriptionFacade.putPledge({
      ...pledge,
      commands: [CommandEnum.COMPLETE_SIGNATURE_PLACE],
    });

    this.subscriptionFacade.loadingService
      .showLoadingUntilCompleted(command$)
      .pipe(
        take(1),
        catchError(() => of(null)),
      )
      .subscribe();
  }

  floorValue(value: number) {
    return Math.floor(value * 100) / 100;
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
